import { trigger, transition, style, animate, group, query, animateChild } from '@angular/animations';

export const contentTransition = trigger('contentTransition', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(':enter', [
      style({  opacity: '0', zIndex: 1 }),
    ], { optional: true }),
    query(':leave', [
      style({  opacity: '1', zIndex: 0 }),
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':enter', [
        style({ opacity: 0/*, transform: 'translateY(20px)'*/ }),
        animate('400ms ease-in-out', style({ opacity: 1, /*transform: 'translateY(0)'*/ })),
        animateChild() // Run child animations for entering page
      ], { optional: true }),
      query(':leave', [
        style({ opacity: 1/*, transform: 'translateY(0)' */}),
        animate('400ms ease-in-out', style({ opacity: 0, /*transform: 'translateY(-20px)'*/ })),
        animateChild() // Run child animations for leaving page
      ], { optional: true })
    ])
  ])
]);